import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceWidgetConfigurationInstallRoute: InvariantJiraRoute = {
	name: 'csm-experience-widget-configuration-install',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/embed/:widgetId/install',
	exact: true,
};
